<template>
  <div>
    <el-steps :active="active" class="step-bg" finish-status="success">
      <el-step :title="step1" icon="el-icon-upload"></el-step>
      <el-step :title="step2" icon="el-icon-edit"></el-step>
      <el-step :title="step3" icon="el-icon-files"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step1: "步骤1",
      step2: "步骤2",
      step3: "步骤3",
      active: 0,
    };
  },
  props: {
    prop_active: { Type: Number, default: 0 },
  },
  methods: {
    setData(active) {
      this.active = active;
      if (active > 0) {
        let fetchList = [];
        for (let i = 0; i < active; i++) {
          fetchList.push(i + 1);
        }
        if (fetchList.length > 0) {
          fetchList.forEach((i) => {
            this["step" + i] = "完成";
          });
        }
      }
      this["step" + (active + 1)] = "進行中";
    },
  },
  created() {
    this.active = this.prop_active;
    this.setData(this.active);
  },
};
</script>

<style scoped>
.el-step >>> .el-step__icon.is-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid;
  border-color: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/UploadStep.vue